import ServerError from './ServerError.vue'

export default ServerError
